(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["joygrit-mobile-color-picker"] && !Shopify.designMode) return;
  try {
    class JoyGritMobileColorPicker extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('[data-testid="product-information"]');
      this.mainPicker = this.productSection?.querySelector('variant-picker[ref="mainVariantPicker"]');
      this.handleClick = this.handleClick.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.addEventListener('click', this.handleClick);
      this.mainPicker?.addEventListener('change', this.handleVariantChange);
      this.syncFromMainPicker();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.mainPicker?.removeEventListener('change', this.handleVariantChange);
    }

    handleClick(event) {
      const button = event.target.closest('button[data-option-value-id]');
      if (!button || button.disabled || !this.mainPicker) return;

      const optionValueId = button.dataset.optionValueId;
      const input = this.mainPicker.querySelector(`input[data-option-value-id="${CSS.escape(optionValueId)}"]`);
      if (!input) return;

      input.click();
      requestAnimationFrame(() => this.syncFromMainPicker());
    }

    handleVariantChange() {
      requestAnimationFrame(() => this.syncFromMainPicker());
    }

    syncFromMainPicker() {
      if (!this.mainPicker) return;

      const selectedInput =
        this.mainPicker.querySelector('fieldset[data-option-name="color"] input:checked') ||
        this.mainPicker.querySelector('fieldset[data-option-name="colour"] input:checked');

      if (!selectedInput) return;

      const selectedId = selectedInput.dataset.optionValueId;
      const selectedValue = selectedInput.value;
      const selectedLabel = this.querySelector('[data-selected-color]');

      if (selectedLabel) selectedLabel.textContent = selectedValue;

      this.querySelectorAll('button[data-option-value-id]').forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.optionValueId === selectedId ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('joygrit-mobile-color-picker')) {
    customElements.define('joygrit-mobile-color-picker', JoyGritMobileColorPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
